import React from "react";
import { WarningCircleIcon, ArrowsClockwiseIcon } from "@phosphor-icons/react";

export class ErrorBoundary extends React.Component {
  state = { err: null, info: null };

  static getDerivedStateFromError(err) {
    return { err };
  }

  componentDidCatch(err, info) {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error("[Megatron error boundary]", err, info);
  }

  render() {
    if (!this.state.err) return this.props.children;
    const detail = (this.state.err?.stack || this.state.err?.message || String(this.state.err)).slice(0, 600);
    return (
      <div className="min-h-screen bg-zinc-50 p-6 flex items-center justify-center">
        <div className="max-w-xl w-full rounded-sm border border-red-200 bg-white p-8 shadow-sm">
          <div className="flex items-center gap-3">
            <WarningCircleIcon size={28} weight="fill" className="text-red-600 flex-shrink-0" />
            <h1 className="font-display text-2xl font-bold tracking-tight text-red-900">
              Something crashed
            </h1>
          </div>
          <p className="mt-3 text-sm text-zinc-600">
            Megatron hit an unexpected error. Your data is safe — no changes were lost.
            Please copy the detail below and share it with support.
          </p>
          <pre className="mt-4 max-h-60 overflow-auto rounded-sm border border-zinc-200 bg-zinc-50 p-3 font-mono text-[11px] leading-tight text-zinc-800 whitespace-pre-wrap break-all">
            {detail}
          </pre>
          <div className="mt-5 flex gap-2">
            <button
              onClick={() => window.location.reload()}
              className="inline-flex items-center gap-2 rounded-sm bg-amber-500 px-5 py-2 text-sm font-bold text-zinc-950 hover:bg-amber-600"
            >
              <ArrowsClockwiseIcon size={14} weight="bold" /> Reload page
            </button>
            <a
              href="/"
              className="inline-flex items-center rounded-sm border border-zinc-200 bg-white px-5 py-2 text-sm font-semibold text-zinc-900 hover:bg-zinc-50"
            >
              Home
            </a>
          </div>
        </div>
      </div>
    );
  }
}
